import * as types from "./sb_actionTypes";

const initialState = {
    subscriptonData: [],
    subscriptonSummary: [],
    totalPages: 0,

    loading: true,
};

const sbReducers = (state = initialState, action) => {
    switch (action.type) {

        case types.get_subscription_data:
            return {
                ...state,
                subscriptonData: action.payload,
                loading: false,
            };
        case types.get_subscription_summary:
            return {
                ...state,
                subscriptonSummary: action.payload,
                loading: false,
            };
        case types.get_total_pages:
            return {
                ...state,
                totalPages: action.payload,
                loading: false,
            };
        default:
            return state;
    }
};

export default sbReducers;